import React from "react"

export const SearchLinks = ({
  quickLinks,
  quickLinksText,
  setCurrentRefinement,
}) => {
  return (
    <div className="product-finder__search-links">
      {quickLinks && (
        <div className="product-finder__search-links--common">
          <p className="product-finder__search-links--header">
            {quickLinksText}
          </p>
          <ul className="product-finder__search-links__list">
            {quickLinks?.map((d, i) => (
              <li key={`common-search-${i}`}>
                <button
                  className="product-finder__search-links--search-link"
                  onClick={() => setCurrentRefinement(d.searchString)}
                  tabIndex={0}
                >
                  {d.searchString}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

export default SearchLinks
